import { FBXLoader as BaseLoader } from 'three/examples/jsm/loaders/FBXLoader'

export class FBXLoader {
  constructor (loadingManager) {
    this.loader = new BaseLoader(loadingManager)
  }

  load (url, objectsOnly = false, setupItem = ()=>{}) {
    return new Promise((resolve, reject) => {
      this.loader.load(url, object => {
        const toRemove = []

        object.traverse( child => {
          if (child.isMesh) {
            setupItem(child)
          }
          else {
            if (objectsOnly && child.children.length === 0) {
              toRemove.push(child)
            }
          }
        })

        if (objectsOnly) {
          toRemove.forEach(obj => object.remove(obj))
        }

        resolve(object)
      }, null, reject)
    }, loading => console.log('loading', loading), error => console.log('error', error))
  }
}
